const brands = {
    AquaCalPentairBus: "AquaCalPentairBus",
    JandyBus: "JandyBus",
    GoldlineBus: "GoldlineBus",
    PentairBus: "PentairBus",
    Modbus9600N1SerialBus: "Modbus9600N1SerialBus",
};

const cohabitatableBuses = [
    [
        brands.JandyBus,
        brands.GoldlineBus,
    ],
    [
        brands.PentairBus,
        brands.GoldlineBus,
    ],
    [
        brands.Modbus9600N1SerialBus,
        brands.GoldlineBus,
    ],
    [
        brands.PentairBus,
        brands.AquaCalBus,
    ],
    [
        brands.AquaCalPentairBus,
        brands.JandyBus,
        brands.GoldlineBus
    ],
    [
        brands.Modbus9600N1SerialBus,
        brands.JandyBus,
    ],
];

export default cohabitatableBuses;
